<div class="header">
  <div class="header-cont">
    <h2>{{ 'change_password.title' | translate }}</h2>
  </div>
</div>

<form [formGroup]="passwords">
  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'change_password.old' | translate }}</h4>
    </div>
  </div>
  
  <div class="single-section">
    <div class="section-cont">
      <mat-form-field class="section-input">
        <mat-label>{{ 'change_password.old' | translate }}</mat-label>
        <input matInput type="password" formControlName="oldPassword" required>
      </mat-form-field>
      <div *ngIf="((oldPassword.touched || oldPassword.dirty) && oldPassword.invalid) || isOldWrong" class="error-message">
        <p *ngIf="oldPassword?.errors?.required">{{ 'change_password.required' | translate }}</p>
        <p *ngIf="isOldWrong">{{ 'change_password.wrong_old' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'change_password.new' | translate }}</h4>
    </div>
  </div>
  
  <div class="single-section">
    <div class="section-cont">
      <mat-form-field class="section-input">
        <mat-label>{{ 'change_password.new' | translate }}</mat-label>
        <input matInput type="password" formControlName="newPassword" required>
      </mat-form-field>
      <div *ngIf="(newPassword.touched || newPassword.dirty) && newPassword.invalid" class="error-message">
        <p *ngIf="newPassword?.errors?.required">{{ 'change_password.required' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'change_password.repeat' | translate }}</h4>
    </div>
  </div>
  
  <div class="single-section">
    <div class="section-cont">
      <mat-form-field class="section-input">
        <mat-label>{{ 'change_password.repeat' | translate }}</mat-label>
        <input matInput type="password" formControlName="newPasswordRepeated" required>
      </mat-form-field>
      <div *ngIf="((newPasswordRepeated.touched || newPasswordRepeated.dirty) && newPasswordRepeated.invalid) || isNewDifferent"
          class="error-message">
        <p *ngIf="newPasswordRepeated?.errors?.required">{{ 'change_password.required' | translate }}</p>
        <p *ngIf="isNewDifferent">{{ 'change_password.different' | translate }}</p>
      </div>
    </div>
  </div>
</form>

<div *ngIf="isChanged" class="single-section">
    <div class="section-cont">
        <p class="success-message">{{ 'change_password.changed' | translate }}</p>
    </div>
</div>

<div class="page-footer">
    <div class="page-footer-btns">
        <button mat-raised-button class="save-icon-btn" (click)="changePwd()" [disabled]="!passwords.valid">
            <mat-icon>save</mat-icon>
        </button>
    </div>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
